export const api = {
  users: "user",
  projects: "project",
  offices: "office",
  auth: "authorization",
  folders: "folder",
  organisations: "organisation",
  foreign: "foreign",
  documents: "document"
};
